// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1MePt","info":"PatientInfo_info__1Cvnq"};